import React, { useRef, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import DynamicButton from "../DynamicButton/DynamicButton";

const TableExcelActions = ({ columns, filteredData, api }) => {
  const fileInputRef = useRef(null);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [showDateModal, setShowDateModal] = useState(false);

  const generateExcel = (data) => {
    const excelColumns = columns.filter((col) => col.excel !== "false");
    const totalFields = excelColumns.filter((col) => col.excelTotal === "true");

    const excelData = data.map((row, index) => {
      const flattenedRow = {};
      flattenedRow["S.No"] = index + 1;

      let dateValue = null;
      let timeValue = null;

      excelColumns.forEach((col) => {
        const fieldPath = col.field.split(".");
        let value = row;

        for (let i = 0; i < fieldPath.length; i++) {
          if (Array.isArray(value)) {
            const remainingPath = fieldPath.slice(i).join(".");
            value = value
              .map((item) => {
                const keys = remainingPath.split(".");
                let nestedValue = item;
                for (const k of keys) nestedValue = nestedValue?.[k];
                return nestedValue;
              })
              .filter(Boolean)
              .join(", ");
            break;
          } else {
            value = value?.[fieldPath[i]];
          }
        }

        if (col.type === "Date") dateValue = value;
        if (col.type === "Time") timeValue = value;

        flattenedRow[col.label] = value ?? "";
      });

      if (dateValue && timeValue) {
        const formattedDate = new Date(dateValue).toISOString().split("T")[0];

        flattenedRow["Date & Time"] = `${formattedDate} ${timeValue}`;

        delete flattenedRow["Date"];
        delete flattenedRow["Time"];
      }

      return flattenedRow;
    });
    if (totalFields.length > 0) {
      const totalRow = {};
      totalRow["S.No"] = "TOTAL";

      excelColumns.forEach((col) => {
        if (col.excelTotal === "true") {
          const total = data.reduce((sum, row) => {
            const value = col.field
              .split(".")
              .reduce((acc, key) => acc?.[key], row);
            return sum + (Number(value) || 0);
          }, 0);

          totalRow[col.label] = total;
        } else {
          totalRow[col.label] = "";
        }
      });

      excelData.push(totalRow);
    }

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "FilteredData");

    XLSX.writeFile(workbook, "filtered_data.xlsx");
  };

  const handleDownload = () => {
    if (!dateFrom || !dateTo) {
      alert("Please select Date From and Date To");
      return;
    }

    const from = new Date(dateFrom);
    const to = new Date(dateTo);
    to.setHours(23, 59, 59, 999);

    const dateColumn = columns.find((col) => col.type === "Date");

    if (!dateColumn) {
      alert("No Date column found in configuration.");
      return;
    }

    const rangeFilteredData = filteredData.filter((row) => {
      const rowDate = new Date(
        dateColumn.field.split(".").reduce((acc, key) => acc?.[key], row),
      );

      return rowDate >= from && rowDate <= to;
    });

    if (rangeFilteredData.length === 0) {
      alert("No records found for selected date range");
      return;
    }

    generateExcel(rangeFilteredData);
    setShowDateModal(false);
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!api) {
      alert("⚠️ Upload not available.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`${api}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("✅ Upload complete.");
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("❌ Upload failed.");
    }
  };

  const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  };

  const modalStyle = {
    background: "#fff",
    padding: "2rem",
    borderRadius: "10px",
    minWidth: "300px",
  };

  return (
    <>
      <div
        className="excel-actions"
        style={{ display: "flex", gap: "0.75rem" }}
      >
        <DynamicButton
          text="Download Excel"
          icon="fa-download"
          size="sm"
          variant="primary"
          onClick={() => setShowDateModal(true)}
        />

        {/* <DynamicButton
          text="Upload Excel"
          icon="fa-upload"
          size="sm"
          variant="secondary"
          onClick={() => fileInputRef.current?.click()}
        /> */}

        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx,.xls"
          onChange={handleUpload}
          style={{ display: "none" }}
        />
      </div>

      {showDateModal && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <h3>Select Date Range</h3>

            <div style={{ marginBottom: "1rem" }}>
              <label>Date From:</label>
              <input
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
              />
            </div>

            <div style={{ marginBottom: "1rem" }}>
              <label>Date To:</label>
              <input
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
              />
            </div>

            <div style={{ display: "flex", gap: "1rem" }}>
              <button onClick={handleDownload}>Download</button>
              <button onClick={() => setShowDateModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TableExcelActions;
